
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-7a5885be&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Highlights.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Highlights.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-7a5885be!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Highlights.vue"),
  /* scopeId */
  "data-v-7a5885be",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Highlights.vue
// module id = 27
// module chunks = 1